document.addEventListener("DOMContentLoaded", function () {
    // One shared, debounced observer instead of one document-wide observer per fix.
    // Every DOM change used to run ~16 full-page jQuery scans synchronously; now the
    // registered fixes run together, at most once per 150ms, after the DOM settles.
    let a11yFixes = [];
    let a11yTimer = null;
    let runA11yFixes = function () {
        a11yTimer = null;
        a11yFixes.forEach(function (fix) {
            try {fix();} catch (err) {}
        });
    };
    let a11yObserve = function (fix) {a11yFixes.push(fix);};
    new MutationObserver(function () {
        if (a11yTimer) return;
        a11yTimer = setTimeout(runA11yFixes, 150);
    }).observe(document.body, {childList: true, subtree: true});
    // start code
    $('.shopify-policy__container .shopify-policy__body strong').attr({'role':'heading','aria-level':'2'});
    $('#AnnouncementSlider').removeAttr('tabindex');
    let announcementSlide = $('#AnnouncementSlide-73fd0048-0dcb-47bb-a1e9-e6ac9e04b582');
    announcementSlide.prepend(announcementSlide.find('.announcement-text'));
    $("form.multi-selectors button.faux-select.disclosure__toggle").each(function () {
    $(this).attr("role", "combobox").attr("aria-label", "Country Currency, " + $(this).find(".disclosure-list__label").text().trim());});
    let fixGiftCloseButton = function () {
    $("wrapped-gift-block").each(function () {
        if (!this.shadowRoot) return;
        $(this.shadowRoot).find("gift-dialog-header h1").attr({"role": "heading","aria-level": "2"});
        $(this.shadowRoot).find("gift-dialog-content .gift-product-content h1,gift-dialog-content .gift-product-content h2").attr('role','none');
        $(this.shadowRoot).find("gift-dialog-content img").attr('alt','');
        $(this.shadowRoot).find("gift-dialog-content #content .gift-option-group").next(".required_message").remove().end().after('<div class="required_message">Fields marked with * are required.</div>');
        $(this.shadowRoot).find("shopify-variant-selector").each(function () {if (!this.shadowRoot) return;
            $(this.shadowRoot).find("form.product-form select.select").attr('aria-label','Wrapping Paper Theme');
        });
        $(this.shadowRoot).find("gift-dialog-header button#close-button").each(function () {
            $(this).attr("aria-label", "X (Close)");
            if (this.a11yLabelObserved) return;
            this.a11yLabelObserved = true;
            new MutationObserver(function () {
                if ($(this).attr("aria-label") !== "X (Close)") {
                    $(this).attr("aria-label", "X (Close)");
                }
            }.bind(this)).observe(this, {
                attributes: true,attributeFilter: ["aria-label"]});
        });
$(this.shadowRoot).find("gift-block-actions").each(function () {
    if (!this.shadowRoot) return;
    let $root = $(this.shadowRoot);
    $(this).removeAttr("aria-busy");
    if (!this.a11yBusyObserved) {
    this.a11yBusyObserved = true;
    new MutationObserver(function () {
        $(this).removeAttr("aria-busy");
    }.bind(this)).observe(this, {attributes: true,attributeFilter: ["aria-busy"]});
    }
    $root.find("#save-button, #remove-button").each(function () {
        if ($(this).data("loading-a11y")) return;
        $(this).data("loading-a11y", true);
        let button = this;
        let $status = $('<span role="status" aria-live="polite" aria-atomic="true"></span>').css({position: "absolute",width: "1px",height: "1px",overflow: "hidden",clip: "rect(0 0 0 0)"}).appendTo($root);
        new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.attributeName === "loading" &&
                    button.hasAttribute("loading")) {
                    $(button).removeAttr("aria-busy");
                    $status.text("");
                    setTimeout(function () {$status.text("Loading");}, 10);
        }});}).observe(button, {attributes: true,attributeFilter: ["loading", "aria-busy"]});});
});
$(this.shadowRoot).find("wrapped-message-field").each(function () {
    let $field = $(this);
    let $counter = $field.find("span.counter");
    let $textarea = $field.find("textarea");
    if (!$counter.length || !$textarea.length) return;
    $counter.attr("aria-hidden", "true");
    let counterId = "message-character-count-" + $textarea.attr("id");
    let $srText = $field.find("#" + counterId);
    if (!$srText.length) {$srText = $('<span style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0); visibility:hidden;"></span>').attr("id", counterId).insertAfter($counter);}
    $textarea.attr("aria-describedby", counterId);
    let updateCounter = function () {
        let text = $counter.text().trim().split("/");
        if (text.length === 2) {$srText.text(text[0].trim() +" of " +text[1].trim() +" characters used. Maximum " +text[1].trim() +" characters.");}};
    updateCounter();
    if (!$counter.data("counter-a11y-observed")) {new MutationObserver(updateCounter).observe($counter[0], {childList: true,characterData: true,subtree: true});
        $counter.data("counter-a11y-observed", true);}
});
        
});
};
fixGiftCloseButton();
a11yObserve(fixGiftCloseButton);
let fixGiftFields = function () {
    $("wrapped-gift-block").each(function () {
        if (!this.shadowRoot) return;
        $(this).css("--shadow-form-element-placeholder-text-color", "#737373");
        // Inject focus styles once per shadow root (previously re-appended on every DOM change).
        if (!$(this.shadowRoot).children("style.a11y-focus").length) {
            $(this.shadowRoot).append(
                "<style class='a11y-focus'>button#close-button:focus-visible { outline: 2px solid #000 !important; outline-offset: 2px !important; } gift-block-launcher button.gift-block__launcher:focus-visible { outline: 2px solid #000 !important; outline-offset: 3px !important; }</style>");
        }
    $(this.shadowRoot).find("gift-block-actions").each(function () {
            if (!this.shadowRoot) return;
            if (!$(this.shadowRoot).children("style.a11y-focus").length) {
                $(this.shadowRoot).append(
                    "<style class='a11y-focus'>button#save-button:focus-visible { outline: 2px solid #000 !important; outline-offset: 4px !important; }</style>");
            }
        });
$(this.shadowRoot).find("dialog#gift-block-modal").attr("aria-label", "BK Premium Gift Wrapping");
        $(this.shadowRoot).find("wrapped-message-field").each(function () {$(this).find("input").attr("required", "required");
        $(this).find("label").each(function () {
    if (
        ($(this).text().trim() === "To" || $(this).text().trim() === "From") && !$(this).find(".required-star").length
    ) {$(this).append('<span class="required-star" aria-hidden="true"> *</span>');}}); 

        });
});};
fixGiftFields();
a11yObserve(fixGiftFields);
setTimeout(() => {
    // $('footer form.contact-form .note--success').attr('role','alert');
    $('#mahina-app .ma-wrapper h2.ma-calendar-header').attr({'role':'heading','aria-level':'1'});
    $('body.our-designer-collections .text-center.aos-init h3').attr({'role':'heading','aria-level':'2'});
    $('body.our-designer-collections .text-center.aos-init .rte-setting').attr('role','list');
    $('body.our-designer-collections .text-center.aos-init .rte-setting p').attr('role','listitem');
    $("body.rewards-page-247172 .rte .enlarge-text h1").filter(function () {return $.trim($(this).text()) === "VIP LOYALTY TIERS";}).attr({"role": "heading","aria-level": "2"});
    $('.jdgm-carousel-wrapper .jdgm-all-reviews-rating-wrapper .jdgm-all-reviews-rating').removeAttr('tabindex');

}, 1500);
$(".product__thumbs .product__thumbs--scroller .product__thumb").on("click", function () {$(".product__thumbs--scroller .product__thumb").removeAttr("aria-current");
    $(this).attr("aria-current", "true");});
// 

let keyboardFocus = false;
$(document).on("keydown", ".swatch-view-item[role='radio']", function (e) {
    if (e.key === "ArrowLeft" || e.key === "ArrowRight") {keyboardFocus = true;}
    if (e.key === "Enter" || e.key === " ") {keyboardFocus = false;
        $(this).find(".swatch-button").attr("swatch-url", $(this).find(".swatch-button").data("swatch-url"));}});
$(document).on("focus", ".swatch-view-item[role='radio']", function () {
    let button = $(this).find(".swatch-button");
    if (keyboardFocus && button.attr("swatch-url")) {button.data("swatch-url", button.attr("swatch-url"));
        button.removeAttr("swatch-url");}});
$(document).on("keyup", ".swatch-view-item[role='radio']", function (e) {if (e.key === "ArrowLeft" || e.key === "ArrowRight") {keyboardFocus = false;}});

let fixChartLink = function () {
    // Namespaced so we only replace our own handler, not the app's keydown handlers.
    $('form.product-single__form .ks-chart-modal-link,small#shopify-buyer-consent span').attr({
        'role': 'button',
        'tabindex': '0'}).off('keydown.a11yButton').on('keydown.a11yButton', function (e) {if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');}
    });
// 
$('.kiwi-sizing-modal .ks-modal-close').attr({'role':'button','tabindex':'0','aria-label':'close'});
$(".modal--quick-shop.modal--is-active").attr({
        "role": "dialog",
        "aria-modal": "true",
        "aria-label": "Quick Shop dialog"
    });
    let richtext = $('.kl-private-reset-css-Xuajs1 form .go239006991 .klaviyo-form-richtext');
    richtext.attr('aria-hidden', 'true');
    if (richtext.length && !richtext.next('h2.sr-only').length) {richtext.after('<h2 class="sr-only">UNLOCK 10% off YOUR FIRST ORDER</h2>');}
$('.kl-private-reset-css-Xuajs1 form .go310894487 .klaviyo-form-richtext').attr('role','alert');
if (!$("#insta-feed #insta-status").length) {
    $("#insta-feed").append(
        '<div class="sr-only" id="insta-status" role="status" aria-live="polite"></div>'
    );
}

};
fixChartLink();
a11yObserve(fixChartLink);
$(document).on("click", "form.product-single__form .ks-chart-modal-link", function () {
    setTimeout(function () {$(".kiwi-sizing-modal").find("button, a, input, select, textarea, [tabindex]:not([tabindex='-1'])").first().trigger("focus");
    }, 100);});
let fixCalendarDates = function () {
    $(".ma-calendar form.ma-calendar__dates label.ma-date").each(function () {
        let input = $(this).prev("input");
        $(this).attr({"role": "radio","tabindex": $(this).hasClass("ma-has-event") ? "0" : "-1","aria-checked": input.prop("checked") ? "true" : "false","aria-label": $(this).text().trim()});
    });
    $("#mahina-app .ma-list-layout .ma-list-layout--active")
    .attr({
        "role": "button",
        "tabindex": "0"
    })
    .off("keydown.maList")
    .on("keydown.maList", function (e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            this.click();
        }
    });
$("#mahina-app .ma-add-calendar.ma-icon-wrapper").attr({"role": "combobox","aria-label": "Add to calendar","tabindex": "0","aria-expanded": "false"});
$('#marsello-widget-root .cp-launcher .cp-launcher-btn').attr({'role':'button','tabindex':'0'});
$("#marsello-widget-root .cp-launcher .cp-launcher-btn").off("keydown.a11yButton").on("keydown.a11yButton", function (e) {if (e.key === "Enter" || e.key === " ") {$(this).trigger("click");}});
let $searchInput = $('predictive-search .search__input#Search');
let $predictiveSearch = $('predictive-search #predictive-search');

if ($predictiveSearch.css("display") === "block") {
    $searchInput.attr("aria-expanded", "true");
} else {
    $searchInput.attr("aria-expanded", "false");
} 

$('.product-recommendations-placeholder .product-single__related.grid.grid--uniform.aos-init.flickity-enabled').removeAttr('tabindex');
$(".product__main-photos [data-product-photos].product-slideshow").attr("tabindex", "-1");
};
fixCalendarDates();
a11yObserve(fixCalendarDates);
$(document).on("keydown", ".ma-calendar form.ma-calendar__dates label.ma-date", function (e) {
    let current = $(this);
    let target;
    if (e.key === "ArrowLeft") {
        e.preventDefault();
        target = current.parent().prevAll("div").has("label.ma-date.ma-has-event").first().find("label.ma-date.ma-has-event");
    }
    if (e.key === "ArrowRight") {
        e.preventDefault();
        target = current.parent().nextAll("div").has("label.ma-date.ma-has-event").first().find("label.ma-date.ma-has-event");
    }
    if (target && target.length) {
        $(".ma-calendar form.ma-calendar__dates label.ma-date").attr("tabindex", "-1").attr("aria-checked", "false");
        target.attr({"tabindex": "0","aria-checked": "true"}).focus();
    }
    if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        $(this).prev("input")[0].click();
        $(".ma-calendar form.ma-calendar__dates label.ma-date").attr("tabindex", "-1").attr("aria-checked", "false");
        $(this).attr({"tabindex": "0","aria-checked": "true"});
        $(".ma-list-layout .ma-list-layout--active").first().focus();}
});
$(document).on("click", ".ma-calendar form.ma-calendar__dates label.ma-date", function () {
    let current = $(this);
    current.prev("input")[0].click();
    $(".ma-calendar form.ma-calendar__dates label.ma-date").attr({"tabindex": "-1","aria-checked": "false"});
    current.attr({"tabindex": "0","aria-checked": "true"});
$(".ma-list-layout .ma-list-layout--active").first().focus();
});
let fixKlaviyoLoading = function () {
    let button = $('.klaviyo-form button');
    if (!button.length) return;
    // Watch the spinner class on the Klaviyo form only, not on the whole page.
    $('.klaviyo-form').each(function () {
        if (this.a11yLoadingObserved) return;
        this.a11yLoadingObserved = true;
        new MutationObserver(fixKlaviyoLoading).observe(this, {subtree: true,attributes: true,attributeFilter: ['class']});
    });
    if (!button.next('.sr-only.klaviyo-loading-status').length) {
        button.after('<div class="sr-only klaviyo-loading-status" role="status" aria-live="polite" aria-atomic="true"></div>');
    }
    let status = button.next('.klaviyo-loading-status');
    if (
        button.hasClass('klaviyo-spinner') ||
        button.find('.klaviyo-spinner').length
    ) {
        if (status.text() !== 'Loading') {status.text('Loading');}
    } else {if (status.text() !== '') {status.text('');}}
};
fixKlaviyoLoading();
a11yObserve(fixKlaviyoLoading);
// 
$(document).on(
  "click",
  "#insta-feed button.instafeed-new-arrow-next, #insta-feed button.instafeed-new-arrow-prev",
  function () {
    const $status = $("#insta-feed #insta-status");

    $status.empty();

    setTimeout(() => {
      $status.text("Slide changed");

      setTimeout(() => {
        $status.empty();
      }, 1000);
    }, 1000);
  }
);
$('.index-section .theme-block .rte .enlarge-text h6').attr('role','none');
$(".header-item--navigation a.site-nav__link.js-search-header").on("click", function () {$("predictive-search").css("display", "flex");});
$("predictive-search button.btn--close-search").on("click", function () {
    $("predictive-search").css("display", "none");
    $(".header-item--navigation a.site-nav__link.js-search-header").focus();
});
let updateInstafeedTabindex = function () {
    $(".instafeed-new-layout-container").each(function () {
        let $container = $(this);
        let containerRect = this.getBoundingClientRect();
        $container.find(".instafeed-new-layout-item").each(function () {
            let $item = $(this);
            let $interactive = $item.find('[data-instafeed-role-button="true"]');
            if (!$interactive.length) return;
            let itemRect = this.getBoundingClientRect();
            let isVisible =
                itemRect.right > containerRect.left &&
                itemRect.left < containerRect.right &&
                itemRect.bottom > containerRect.top &&
                itemRect.top < containerRect.bottom;
            $interactive.attr("tabindex", isVisible ? "0" : "-1");
        });});};
updateInstafeedTabindex();
let instafeedTimer;
let instaFeed = document.querySelector("#insta-feed");
if (instaFeed) {
    new MutationObserver(function () {
        clearTimeout(instafeedTimer);
        instafeedTimer = setTimeout(function () {updateInstafeedTabindex();}, 200);
    }).observe(instaFeed, {childList: true,subtree: true});
}
// 
let fixSwatchRadio = function () {
    $(".grid-product__meta variant-swatch-king ul.swatch-view").each(function () {
        let $group = $(this);
        let $items = $group.children("li[role='radio']");
        if (!$items.length) return;
        // Set up each group once; re-running on every DOM change used to reset the
        // selection back to the first swatch.
        if ($group.data("swatchA11y") === $items.length) return;
        $group.data("swatchA11y", $items.length);
        let $checked = $items.filter("[aria-checked='true']").first();
        if (!$checked.length) {$checked = $items.first();}
        $items.attr({"tabindex": "-1","aria-checked": "false"});
        $checked.attr({"tabindex": "0","aria-checked": "true"});
        $items.off("keydown.swatchA11y").on("keydown.swatchA11y", function (e) {
            if (
                e.key !== "ArrowRight" &&
                e.key !== "ArrowLeft" &&
                e.key !== "ArrowDown" &&
                e.key !== "ArrowUp"
            ) {
                return;
            }
            e.preventDefault();
            let currentIndex = $items.index(this);
            let newIndex = currentIndex;
            if (e.key === "ArrowRight" || e.key === "ArrowDown") {
                newIndex = (currentIndex + 1) % $items.length;
            }
            if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
                newIndex = (currentIndex - 1 + $items.length) % $items.length;
            }
            let $newItem = $items.eq(newIndex);
            $items.attr({"tabindex": "-1","aria-checked": "false"});
            $newItem.attr({"tabindex": "0","aria-checked": "true"});
            $newItem[0].focus();
            $newItem.find(".swatch-button").trigger("click");
        });});
};
fixSwatchRadio();
a11yObserve(fixSwatchRadio);
$(".product-block--tab .collapsibles-wrapper .collapsible-content__inner.rte p strong").filter(function () {return $.trim($(this).text()) === "Return Policy";}).attr({"role": "heading","aria-level": "2"});
$(".product-block--tab .collapsibles-wrapper .collapsible-content__inner.rte p strong")
    .filter(function () {
        return $.trim($(this).text()) === "SHIPPING & HANDLING" ||
               $.trim($(this).text()) === "TRACKING INFORMATION";
    }).attr({"role": "heading","aria-level": "2"});
$(".index-section .theme-block h2.h2").filter(function () {return $.trim($(this).text()).replace(/\s+/g, " ") === "EXPLORE THE STORE";}).attr({"role": "heading","aria-level": "1"});
$(".index-section .theme-block h2.h2").filter(function () {return $.trim($(this).text()).replace(/\s+/g, " ") === "Our Designer Collections";}).attr({"role": "heading","aria-level": "1"});
$('.collection-content .collection-grid__wrapper .collection-filter__item--sort label').removeAttr('class');

// 
$('header .site-nav__icons a.site-nav__link.site-nav__link--icon.js-search-header.medium-up--hide').on('click', function () {
    $('header predictive-search').css('display', 'block');
});
// 
if ($("#FilterDrawer").length) {
    let $drawer = $("#FilterDrawer");
    if (!$drawer.data("focus-trap")) {
        $drawer.data("focus-trap", true);
        $drawer.on("keydown.filterA11y", function (e) {
            if (e.key !== "Tab") return;
            let $focusable = $drawer.find('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(":visible");
            if (!$focusable.length) return;
            let first = $focusable[0];
            let last = $focusable[$focusable.length - 1];
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();}
        });
$(document).on("focusin.filterA11y", function () {if ($drawer.hasClass("drawer--is-open") && !$drawer[0].contains(document.activeElement)) {$drawer.find("button.js-drawer-close").first().focus();}});
}}
// 
// 

$("predictive-search").each(function () {
    let $search = $(this);
    if (!$search.data("focus-trap")) {
        $search.data("focus-trap", true);
        $search.on("keydown.searchA11y", function (e) {
            if ($search.hasClass("is-active") && e.key === "Tab") {
                let $focusable = $search.find('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(":visible");
                if (!$focusable.length) return;
                let first = $focusable[0];
                let last = $focusable[$focusable.length - 1];
                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();}
                if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();}}});}
});
// 
if ($(".collection-filter__item--sort").length) {
    if (!$("#sort-notification").length) {
    $('<span id="sort-notification"></span>').css({position: "absolute",width: "1px",height: "1px",overflow: "hidden",clip: "rect(0 0 0 0)"}).appendTo(".collection-filter__item--sort");}
    $(document).off("change.sortA11y", "#SortBy");
    $(document).on("change.sortA11y", "#SortBy", function () {
        sessionStorage.setItem(
            "sortA11y",
            $(this).find("option:selected").text().trim());});
    var sortText = sessionStorage.getItem("sortA11y");
    if (sortText) {sessionStorage.removeItem("sortA11y");
        setTimeout(function () {
            var $status = $("#sort-notification");
            if ($status.length) {
                $status.attr("role", "alert");
                $status.text("Products sorted by " + sortText);
            }}, 300);}
}
// 

// 
setTimeout(function () {
    if (!$(".ma-calendar").length) {return;}
    if (!$("#ma-calendar-announcement").length) {
        $("<span>", {id: "ma-calendar-announcement",role: "status","aria-live": "polite","aria-atomic": "true"}).css({position: "absolute",width: "1px",height: "1px",overflow: "hidden",clip: "rect(0 0 0 0)"}).appendTo("body");}
    function updateCalendar($calendar) {
        var month = $.trim(
            $calendar.find(".ma-calendar__month").text()
        );
        var $oldDates = $calendar.find(
            ".ma-calendar__dates"
        ).first();
        if (!$oldDates.length) {
            return;
        }
        $oldDates
            .siblings(".ma-calendar-a11y-table")
            .remove();
        var $cells = $oldDates.children("div");
        if (!$cells.length) {
            return;
        }
        $oldDates.css({
            display: "none"
        });
        $calendar.find(".ma-calendar__days").css({
            display: "none"
        });
        var $table = $("<table>", {
            class: "ma-calendar__dates ma-calendar-a11y-table",
            "aria-label": month + " calendar"
        });
        var $thead = $("<thead>");
        var $headerRow = $("<tr>");
        $calendar
            .find(".ma-calendar__days > div")
            .each(function () {
                $("<th>", {
                    scope: "col",
                    text: $.trim($(this).text())
                }).appendTo($headerRow);
            });
        $thead.append($headerRow);
        $table.append($thead);
        var $tbody = $("<tbody>");
        var $row = null;
        $cells.each(function (index) {
            if (index % 7 === 0) {
                $row = $("<tr>");
                $tbody.append($row);
            }
            var $oldCell = $(this);
            var $td = $("<td>");
            if (!$oldCell.find("input[type='checkbox']").length) {
                $td.html("&nbsp;");
            } else {
                var $checkbox =
                    $oldCell.find("input[type='checkbox']").first();
                var $label =
                    $oldCell.find("label.ma-date").first();
                var id =
                    $checkbox.attr("id");
                var text =
                    $.trim($label.text());
                var ariaLabel =
                    $label.attr("aria-label") || text;
                var $button = $("<button>", {
                    type: "button",
                    class: "ma-date",
                    "aria-label": ariaLabel,
                    "data-calendar-id": id
                });
                if ($label.hasClass("ma-has-event")) {
                    $button.addClass("ma-has-event");
                }
                if ($label.attr("aria-current")) {
                    $button.attr(
                        "aria-current",
                        $label.attr("aria-current")
                    );
                }
                $button.text(text);
                $button
                    .off("click.calendarDateA11y")
                    .on(
                        "click.calendarDateA11y",
                        function () {
                            var checkbox =
                                document.getElementById(
                                    $(this).attr(
                                        "data-calendar-id"
                                    )
                                );
                            if (checkbox) {
                                checkbox.click();
                            }
                        }
                    );
                $td.append($button);
            }
            $row.append($td);
        });
        $table.append($tbody);
        $oldDates.after($table);
        var today = new Date();
        var todayId =
            today.getFullYear() +
            "-" +
            String(today.getMonth() + 1).padStart(2, "0") +
            "-" +
            String(today.getDate()).padStart(2, "0");
        $table
            .find(".ma-date")
            .removeAttr("aria-current");
        $table
            .find(
                '.ma-date[data-calendar-id="' +
                todayId +
                '"]'
            )
            .attr("aria-current", "date");
    }
    $(".ma-calendar").each(function () {
        updateCalendar($(this));
    });
    $(document)
        .off(
            "click.calendarA11y",
            ".ma-calendar .ma-prev-button, .ma-calendar .ma-next-button"
        )
        .on(
            "click.calendarA11y",
            ".ma-calendar .ma-prev-button, .ma-calendar .ma-next-button",
            function () {
                var $calendar =
                    $(this).closest(".ma-calendar");
                setTimeout(function () {
                    updateCalendar($calendar);
                    var $announcement =
                        $("#ma-calendar-announcement");
                    $announcement.text("");
                    setTimeout(function () {
                        $announcement.text(
                            "Slide changed"
                        );
                    }, 100);
                }, 500);
            }
        );
    $(document)
        .off(
            "click.calendarFocus",
            ".ma-calendar .ma-date"
        )
        .on(
            "click.calendarFocus",
            ".ma-calendar .ma-date",
            function () {
                var $calendar =
                    $(this).closest(".ma-calendar");
                setTimeout(function () {
                    var $container =
                        $calendar.closest(
                            ".ma-list-layout-container"
                        );
                    var $eventList =
                        $container.find(
                            ".ma-list-layout"
                        ).first();
                    if (!$eventList.length) {
                        return;
                    }
                    var $firstInteractive =
                        $eventList
                            .find(
                                'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
                            )
                            .filter(":visible")
                            .first();
                    if ($firstInteractive.length) {
                        $firstInteractive.trigger("focus");
                    }
                }, 500);
            }
        );
}, 2000);
if (!$("#sr-announcer").length) $("<div>", {id: "sr-announcer","aria-live": "polite","aria-atomic": "true",role: "alert",style:"position:absolute; left:-9999px; height:1px; width:1px; overflow:hidden;",}).appendTo("body");
  function announce(message) {const $announcer = $("#sr-announcer");
    $announcer.text("");
    setTimeout(() => {$announcer.text(message);}, 50);}
  function bindAnnounce(selector, message) {
    $(selector).on("click keydown", function (e) {
    if (e.type === "click" ||(e.type === "keydown" &&(e.key === "Enter" || e.key === " " || e.key === "Spacebar"))) {announce(message);}});}
bindAnnounce(".jdgm-carousel__right-arrow,.jdgm-carousel__left-arrow", "Slide changed");
a11yObserve(function () {
    $(".kl-private-reset-css-Xuajs1 form.klaviyo-form input").each(function () {
        let inputId = $(this).attr("id");
        if (inputId && !$(this).prev("label[for='" + inputId + "']").length) {
            $("<label for='" + inputId + "'>Email*</label>").insertBefore(this);
            if (!$(this).prev("label").prev(".required_message").length) {
                $("<div class='required_message'>Fields marked with * are required.</div>").insertBefore($(this).prev("label"));
            }}});
});
let announcementObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        if (mutation.type === "attributes" &&
            mutation.attributeName === "aria-hidden") {
            let announcementSlide =$(mutation.target).closest(".announcement-slider__slide");
            if (!announcementSlide.length) {return;}
            let announcementLink =announcementSlide.find(".announcement-link");
            if (announcementSlide.attr("aria-hidden") === "true") {announcementLink.attr("tabindex", "-1");} else {announcementLink.removeAttr("tabindex");
        }}});
});
$(".announcement-slider__slide").each(function () {announcementObserver.observe(this, {attributes: true,attributeFilter: ["aria-hidden"]});});
a11yObserve(function () {
    $(".product__thumbs--scroller").each(function () {
        let $tablist = $(this);
        let $tabs = $tablist.find(".product__thumb");
        $tablist.attr("role", "tablist");
        $tabs.each(function () {
        let $tab = $(this);
        $tab.attr({"role": "tab","aria-selected": $tab.hasClass("is-active") ? "true" : "false","tabindex": $tab.hasClass("is-active") ? "0" : "-1"});});
    });
});
$(document).off("keydown.productTabs", ".product__thumb").on("keydown.productTabs", ".product__thumb", function (event) {
        if (
            event.key !== "ArrowRight" &&
            event.key !== "ArrowLeft"
        ) {return;}
        event.preventDefault();
        event.stopPropagation();
        let $tablist = $(this).closest(".product__thumbs--scroller");
        let $tabs = $tablist.find(".product__thumb");
        let current = $tabs.index(this);
        let next = current;
        if (event.key === "ArrowRight") {next = (current + 1) % $tabs.length;}
        if (event.key === "ArrowLeft") {next = (current - 1 + $tabs.length) % $tabs.length;}
        let $nextTab = $tabs.eq(next);
        $tabs.attr({"aria-selected": "false","tabindex": "-1"});
        $nextTab.attr({"aria-selected": "true","tabindex": "0"});
        $nextTab[0].click();
        $nextTab.focus();
    });
// 
$(document).off("keydown.calendarTrap", ".ma-calendar").on("keydown.calendarTrap", ".ma-calendar", function (event) {
        if (event.key !== "Tab") {return;}
        let $calendar = $(this);
        let $focusable = $calendar.find('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(":visible:not(:disabled)");
        if (!$focusable.length) {return;}
        let first = $focusable[0];
        let last = $focusable[$focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();}
        if (!event.shiftKey && document.activeElement === last) {event.preventDefault();
            first.focus();}});
//
$('predictive-search').each(function () {
    let $predictiveSearch = $(this);
    let $results = $predictiveSearch.find('#predictive-search');
    let timer;

    if (!$results.length) return;

    if (!$results.next('.predictive-search-announcement').length) {
        $results.after(
            '<div class="predictive-search-announcement visually-hidden" role="status" aria-live="polite" aria-atomic="true"></div>'
        );
    }

    let observer = new MutationObserver(function () {

        clearTimeout(timer);

        timer = setTimeout(function () {

            let $announcement = $results.next('.predictive-search-announcement');

            let suggestions = $results.find('.results--queries li').length;
            let products = $results.find('.results--products li').length;
            let pages = $results.find('.results--pages li').length;
            let collections = $results.find('.results--collections li').length;

            let message = '';

            if (suggestions || products || pages || collections) {
                message = 'Search results available. ';

                if (suggestions) message += suggestions + ' suggestions. ';
                if (products) message += products + ' products. ';
                if (pages) message += pages + ' pages. ';
                if (collections) message += collections + ' collections.';
            } else {
                message = 'No results found.';
            }

            $announcement.text(message);

        }, 300);
    });

    observer.observe($results[0], {
        childList: true,
        subtree: true
    });
});
// 
document.addEventListener("keydown", function (e) {
    if (
        e.key === "Tab" &&
        e.target.closest('.swatch-view [role="radio"]')
    ) {
        e.stopImmediatePropagation();
    }}, true);
// 
    let triggerElement = null;
    $(document).on("click",".ks-chart-modal-link.sizing-chart-modal-link.with-icon",
        function () {triggerElement = this;});
    $(document).on("keydown",".ks-chart-modal-link.sizing-chart-modal-link.with-icon",
        function (e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                triggerElement = this;
                $(this).trigger("click");
            }});
    // Opening focus is handled by the .ks-chart-modal-link click handler above.
    $(document).on("keydown",".kiwi-sizing-modal .ks-modal-close",
        function (e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                $(this).trigger("click");
            }});
    $(document).on("click",".kiwi-sizing-modal .ks-modal-close",
        function () {
            // Return focus once the modal has closed (checks for up to ~1s).
            let tries = 0;
            let returnFocus = function () {
                let $modal = $(".kiwi-sizing-modal");
                if (!$modal.length || !$modal.is(":visible")) {
                    if (triggerElement && document.body.contains(triggerElement)) {
                        triggerElement.focus();
                    }
                } else if (++tries < 10) {
                    setTimeout(returnFocus, 100);
                }
            };
            setTimeout(returnFocus, 50);});
    $(document).on("keydown",".kiwi-sizing-modal",
        function (e) {
            if (e.key !== "Tab") return;
            let $modal = $(this);
            let $focusable = $modal.find('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(":visible");
            if (!$focusable.length) return;
            let firstElement = $focusable.first()[0];
            let lastElement = $focusable.last()[0];
            if (
                e.shiftKey &&
                document.activeElement === firstElement
            ) {
                e.preventDefault();
                lastElement.focus();
            } else if (
                !e.shiftKey &&
                document.activeElement === lastElement
            ) {
                e.preventDefault();
                firstElement.focus();}
    });
// 
 $(".cart__page .cart__item .cart__item-sub .js-qty__wrapper").each(function () {
        let $wrapper = $(this);
        let $input = $wrapper.find(".js-qty__num");
        let $minus = $wrapper.find(".js-qty__adjust--minus");
        let $plus = $wrapper.find(".js-qty__adjust--plus");
        if (!$wrapper.find(".qty-announcement").length) {$wrapper.after('<div class="qty-announcement visually-hidden" role="status" aria-live="polite" aria-atomic="true"></div>');}
        function updateQuantity() {
            let quantity = parseInt($input.val()) || 0;
            if (quantity <= 1) {
                $minus.attr("disabled", "disabled").attr("tabindex", "-1");
            } else {$minus.removeAttr("disabled").removeAttr("tabindex");}}
        updateQuantity();
        $input.on("change input", function () {updateQuantity();});
        $plus.on("click", function () {
            setTimeout(function () {
                updateQuantity();
                let quantity = parseInt($input.val()) || 0;
                $wrapper.next(".qty-announcement").text("Item quantity increased to " + quantity);
            }, 100);});
        $minus.on("click", function () {
            setTimeout(function () {
                updateQuantity();
                let quantity = parseInt($input.val()) || 0;
                $wrapper.next(".qty-announcement").text("Item quantity decreased to " + quantity);}, 100);});
    });
//  
let $trigger;
let modalIsOpen = false;
$(document).off("click.maEventOpen", ".ma-event.ma-list-layout--active button")
.on("click.maEventOpen", ".ma-event.ma-list-layout--active button", function (e) {
    $trigger = $(this);
    modalIsOpen = true;
    setTimeout(function () {
        let $modal = $(".ma-detailed-modal-wrapper .ma-detailed-modal").last();
        if (!$modal.length) return;
        let $focusable = $modal.find(
            'button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
        ).filter(":visible");
        if ($focusable.length) {
            $focusable.first().focus();
        }
    }, 300);
});
$(document).off(
    "click.maEventClose",
    ".ma-detailed-modal .ma-back-to-events button"
).on(
    "click.maEventClose",
    ".ma-detailed-modal .ma-back-to-events button",
    function () {
        modalIsOpen = false;
        setTimeout(function () {
            if ($trigger && $trigger.length) {
                $trigger.focus();
            }
        }, 300);
    }
);
$(document).off("keydown.maModalTrap")
.on("keydown.maModalTrap", function (e) {
    if (!modalIsOpen || e.key !== "Tab") return;
    let $modal = $(".ma-detailed-modal-wrapper .ma-detailed-modal").last();
    if (!$modal.length) return;
    let $focusable = $modal.find(
        'button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
    ).filter(":visible");
    if (!$focusable.length) {
        e.preventDefault();
        return;
    }
    let first = $focusable[0];
    let last = $focusable[$focusable.length - 1];
    if (e.shiftKey) {
        if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
        }
    } else {
        if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    }
});
$(document).off("focusin.maModalTrap")
.on("focusin.maModalTrap", function (e) {
    if (!modalIsOpen) return;
    let $modal = $(".ma-detailed-modal-wrapper .ma-detailed-modal").last();
    if (!$modal.length) return;
    if (
        !$(e.target).closest(".ma-detailed-modal").length
    ) {
        let $focusable = $modal.find(
            'button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
        ).filter(":visible");
        if ($focusable.length) {
            $focusable.first().focus();
        }
    }
});
// 
a11yObserve(function () {

    $(".rewards-page-247172 .page-width .text-center.aos-init.aos-animate").each(function () {
        let $container = $(this);
        let $h3 = $container.children("h3");
        let $heading = $container.find(".rte-setting h1, .rte-setting h2").first();

        if (
            $h3.length &&
            $heading.length &&
            !$container.find(".sr-only.combined-heading").length
        ) {
            let headingText =
                $h3.text().trim() +
                " " +
                $heading.text().trim();

            $h3.attr("aria-hidden", "true");
            $heading.attr("aria-hidden", "true");

            $h3.after(
                '<h3 class="sr-only combined-heading">' +
                headingText +
                '</h3>'
            );
        }
    });
    $('.kl-private-reset-css-Xuajs1 .go3241907364 form .klaviyo-coupon button').attr('aria-label','WELCOME10 coupon code copy');   

});

// 
(function () {
    const drawerSelector = '#NavDrawer';
    let lastTrigger = null;
    let redirecting = false;
    function getDrawer() {
        return document.querySelector(drawerSelector);
    }
    function isOpen(drawer) {
        return drawer &&
            drawer.classList.contains('drawer--is-open');
    }
    function getFocusable(drawer) {
        return Array.from(drawer.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), ' +
            'select:not([disabled]), textarea:not([disabled]), ' +
            '[tabindex]:not([tabindex="-1"])'
        )).filter(function (el) {
            return el.offsetParent !== null;
        });
    }
    function moveInside() {
        const drawer = getDrawer();
        if (!drawer || !isOpen(drawer) || redirecting) return;
        const focusable = getFocusable(drawer);
        if (!focusable.length) return;
        if (!drawer.contains(document.activeElement)) {
            redirecting = true;
            focusable[0].focus({
                preventScroll: true
            });
            setTimeout(function () {
                redirecting = false;
            }, 10);
        }
    }
    function setBackground(open) {
        const selectors = [
            '#MainContent',
            '.shopify-section-group-footer-group',
            '.announcement-bar',
            '#CartDrawer',
            '#VideoModal',
            'header',
            'main',
            'footer',
            '.header-sticky-wrapper',
            '.toolbar.small--hide'
        ];
        const drawer = getDrawer();
        selectors.forEach(function (selector) {
            document.querySelectorAll(selector).forEach(function (element) {
                if (drawer && element.contains(drawer)) return;
                if (open) {
                    element.setAttribute('inert', '');
                    element.setAttribute('aria-hidden', 'true');
                } else {
                    element.removeAttribute('inert');
                    element.removeAttribute('aria-hidden');
                }
            });
        });
    }
    function update() {
        const drawer = getDrawer();
        if (!drawer) return;
        if (isOpen(drawer)) {
            setBackground(true);
            drawer.removeAttribute('inert');
            drawer.removeAttribute('aria-hidden');
            requestAnimationFrame(moveInside);
        } else {
            setBackground(false);
            if (lastTrigger) {
                setTimeout(function () {
                    if (document.contains(lastTrigger)) {
                        lastTrigger.focus();
                    }
                }, 30);
            }
        }
    }
    document.addEventListener('focusin', function (event) {
        const drawer = getDrawer();
        if (!drawer || !isOpen(drawer) || redirecting) return;
        if (!drawer.contains(event.target)) {
            moveInside();
        }
    }, true);
    document.addEventListener('keydown', function (event) {
        const drawer = getDrawer();
        if (!drawer || !isOpen(drawer)) return;
        if (event.key !== 'Tab') return;
        const focusable = getFocusable(drawer);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus({
                preventScroll: true
            });
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus({
                preventScroll: true
            });
        }
    }, true);
    document.addEventListener('click', function (event) {
        const trigger = event.target.closest(
            '#SiteHeader button.js-drawer-open-nav'
        );
        if (trigger) {
            lastTrigger = trigger;
        }
    }, true);
    function init() {
        update();
        const drawer = getDrawer();
        if (drawer) {
            new MutationObserver(function () {
                update();
            }).observe(drawer, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
        new MutationObserver(function () {
            update();
        }).observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['class']
        });
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
let checkboxValue = "";
$(document).on("change", "#CollectionSidebar input[type='checkbox']", function () {
    checkboxValue = $(this).val();
    setTimeout(function () {$("#CollectionSidebar input[type='checkbox']").each(function () {if ($(this).val() === checkboxValue) {
        $(this).focus();
        return false;}
    });}, 2500);
});

// 
a11yObserve(function () {
    $('.ma-event.ma-block-background.ma-list-layout--active').each(function () {
        let eventCard = $(this);
        let heading = eventCard.find('.ma-title').first();
        eventCard.removeAttr('role tabindex');
        if (
            heading.length &&
            !heading.parent().hasClass('ma-event-title-button')
        ) {
            heading.wrap('<button type="button" class="ma-event-title-button"></button>');
        }
    });
});
document.addEventListener('keydown', function (e) {
    if (e.target.closest('.ma-event-title-button')) {
        e.stopPropagation();
    }
}, true);
document.addEventListener('keyup', function (e) {
    if (e.target.closest('.ma-event-title-button')) {
        e.stopPropagation();
    }
}, true);
$(document)
.off('click.maEventButton', '.ma-event-title-button')
.on('click.maEventButton', '.ma-event-title-button', function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    let eventCard = $(this).closest('.ma-event')[0];
    if (eventCard) {
        eventCard.click();
    }
});
// end code
let quickShopTrigger = null;
const quickShopFocusable =
    'a[href]:not([tabindex="-1"]), ' +
    'button:not([disabled]), ' +
    'input:not([disabled]):not([type="hidden"]), ' +
    'select:not([disabled]), ' +
    'textarea:not([disabled]), ' +
    '[tabindex]:not([tabindex="-1"])';
document.addEventListener("click", function (e) {
    const trigger = e.target.closest(".quick-product__btn");
    if (trigger) {quickShopTrigger = trigger;}
}, true);
function getQuickShopFocusable(modal) {
    return Array.from(modal.querySelectorAll(quickShopFocusable)).filter(function (element) {
        if (element.offsetParent === null) {return false;}
        if (element.closest('[aria-hidden="true"]')) {return false;}
        return true;});
}
function getTrapFocusable(modal) {
    return getQuickShopFocusable(modal).filter(function (element) {
        return !element.classList.contains("product__photo-zoom");
    });
}
let focusQuickShop = function () {
    setTimeout(function () {
        const activeModal = document.querySelector(".modal.modal--quick-shop.modal--is-active");
        if (!activeModal || activeModal.contains(document.activeElement)) return;
        const focusable = getQuickShopFocusable(activeModal);
        if (focusable.length) {focusable[0].focus();}}, 300);
};
document.addEventListener("modalOpen", focusQuickShop);
document.addEventListener("quickview:loaded", focusQuickShop);
document.addEventListener("keydown", function (e) {
    if (e.key !== "Tab") return;
    const modal = document.querySelector(".modal.modal--quick-shop.modal--is-active");
    if (!modal) return;
    const allFocusable = getQuickShopFocusable(modal);
    const trapFocusable = getTrapFocusable(modal);
    if (!allFocusable.length || !trapFocusable.length) {
        e.preventDefault();
        return;}
    const firstElement = trapFocusable[0];
    const lastElement = trapFocusable[trapFocusable.length - 1];
    const activeElement = document.activeElement;
    if (e.shiftKey && activeElement === firstElement) {
        e.preventDefault();
        e.stopImmediatePropagation();
        lastElement.focus();
        return;}
    if (!e.shiftKey && activeElement === lastElement) {
        e.preventDefault();
        e.stopImmediatePropagation();
        firstElement.focus();
        return;
    }
}, true);
document.addEventListener("click", function (e) {
    const closeButton = e.target.closest(".modal--quick-shop .js-modal-close");
    if (!closeButton) return;
    setTimeout(function () {
        const activeModal = document.querySelector(".modal.modal--quick-shop.modal--is-active");
        if (!activeModal && quickShopTrigger) {
            quickShopTrigger.focus();
            quickShopTrigger = null;}}, 300);
}, true);
// 
let message = document.querySelector(
    'form.contact-form .note.note--success'
);
if (message) {
    message.setAttribute('role', 'alert');
    message.setAttribute('tabindex', '-1');
    setTimeout(function () {
        message.focus();
    }, 500);
}
// 
a11yObserve(function () {
    $('.events #mahina-app .ma-detailed-modal article header').each(function () {
        const $mahinaHeader = $(this);
        const $mahinaInfo = $mahinaHeader.find('.ma-detailed__info');

        if ($mahinaInfo.length && !$mahinaHeader.children().first().is($mahinaInfo)) {
            $mahinaHeader.prepend($mahinaInfo);
        }
    });

$('#mahina-app .ma-list-layout .ma-event').each(function () {
    let title = $(this).find('.ma-title').text().trim();

    $(this).find('.ma-location svg')
        .removeAttr('aria-hidden')
        .attr({
            'role': 'img',
            'aria-label': title + ' location'
        });
});
    $('.cart .product-form-holder--loaded .product-block--sales-point + .product-block--sales-point').each(function () {
    const $second = $(this);
    const $first = $second.prev('.product-block--sales-point');

    if (
        $first.length &&
        !$first.parent().hasClass('sales-points-wrapper') &&
        !$second.parent().hasClass('sales-points-wrapper')
    ) {
        $first.add($second).wrapAll(
            '<div class="sales-points-wrapper" role="list"></div>'
        );
    }
});
// 
if ($('#StoreAvailabilityDrawer').length) {
    $('#StoreAvailabilityDrawer').attr(
        'aria-label', $('#StoreAvailabilityDrawer .drawer__title > div:first-child').text().trim() + ' dialog'
    );
    // Namespaced: this block re-runs on DOM changes and used to stack a new handler each time.
    $('#StoreAvailabilityDrawer').off('keydown.a11yTrap').on('keydown.a11yTrap', function (e) {
        if (e.key === 'Tab' && e.shiftKey) {
            const $focusable = $(this).find(
                'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
            ).filter(':visible:not(:disabled)');
            if (document.activeElement === $focusable[0]) {
                e.preventDefault();
                $focusable.last().focus();
            }
        }
    });
}
// 
$('.cart .product-form-holder--loaded .sales-points-wrapper .product-block--sales-point').attr('role','listitem');
$('.cart .modal--quick-shop .product-single__meta p.h2.product-single__title,.jdgm-review-widget .jdgm-rev-widg__header form.jdgm-form .jdgm-form__title').attr({'role':'heading','aria-level':'2'});
$("form.filter-form ul").each(function () {
    let $ul = $(this);
    let $group = $ul.closest(".collection-sidebar__group");
    let label = $.trim($group.find("> button.tag-list__header").clone().children().remove().end().text());
    let $items = $ul.children("li");
    $ul.attr({"role": "group","aria-label": label});
    $items.attr("role", "presentation");
    $items.find("input[type='checkbox']").each(function (i) {
        let $input = $(this);
        let name = $input.closest("label").find(".tag__text").text().trim();
        $input.attr({"aria-label": name + ", " + (i + 1) + " of " + $items.length,"aria-posinset": i + 1,"aria-setsize": $items.length});
    });
});
$('.kiwi-sizing-modal .ks-modal-header .modal-title-header,.kiwi-sizing-modal .ks-modal-content .ks-table-header').attr({'role':'heading','aria-level':'2'});
$('.kiwi-sizing-modal .ks-modal-content .ks-html-content p span').first().attr({'role': 'heading','aria-level': '2'});
$('.product__main-photos .flickity-slider .product-main-slide.is-selected').attr('tabindex','-1');
$('variant-swatch-king .swatches-type-products .swatch-single fieldset').attr('role','none');
$('.product-single__meta .sales-points-wrapper .product-block--sales-point ul').attr('role','presentation');
if ($('.jdgm-carousel-item .jdgm-carousel-item__review .jdgm-carousel-item__review-rating').length) {$('.jdgm-carousel-item .jdgm-carousel-item__review .jdgm-carousel-item__review-rating').each(function () {$(this).attr('title', $(this).attr('aria-label'));});}
if ($('.jdgm-review-widget .jdgm-notification .jdgm-notification__inner').length) {$('.jdgm-review-widget .jdgm-notification .jdgm-notification__inner').attr('role', 'alert');}
if (!$('form#CartPageForm .cart__checkout-wrapper #cart-checkout-status').length) {
    $('form#CartPageForm .cart__checkout-wrapper').append(
        '<span id="cart-checkout-status" role="alert" style="position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;"></span>'
    );
}
// 
});

// Create live region for filter announcements
    if (!$('#filter-accessibility-announcement').length) {
        $('body').append(
            '<div id="filter-accessibility-announcement" ' +
            'role="status" ' +
            'aria-live="polite" ' +
            'aria-atomic="true" ' +
            'class="sr-only"></div>'
        );
    }
    $(document).on(
        'change',
        '#CollectionSidebar .filter-form input.tag__input[type="checkbox"]',
        function () {
            const $checkbox = $(this);
            const filterLabel = $checkbox
                .closest('label')
                .find('.tag__text')
                .first()
                .text()
                .trim();
            if (!filterLabel) {
                return;
            }
            const $announcement =
                $('#filter-accessibility-announcement');
            if ($checkbox.prop('checked')) {
                $checkbox.attr(
                    'aria-label',
                    filterLabel + ', filter'
                );
                $announcement.text(
                    'Filter applied: ' + filterLabel
                );
            } else {
                $checkbox.attr(
                    'aria-label',
                    filterLabel + ', filter'
                );
                $announcement.text(
                    'Filter removed: ' + filterLabel
                );
            }
        }
    );
// 
// 
let applyProductVariantRadioAccessibility = function () {
    $('.cart .product-block fieldset.variant-input-wrap').each(function () {
        let $group = $(this);
        let $inputs = $group.find(
            '> .variant-input > input[type="radio"][data-variant-input]'
        );
        let $labels = $group.find(
            '> .variant-input > input[type="radio"][data-variant-input] + label.variant__button-label'
        );
        let $legend = $group.children('legend');
        if (!$inputs.length || !$labels.length) return;
        $group.attr({
            role: 'radiogroup'
        });
        if ($legend.length) {
            let legendId = $legend.attr('id');
            if (!legendId) {
                legendId =
                    'variant-radio-group-' +
                    Math.random().toString(36).substring(2, 9);
                $legend.attr('id', legendId);
            }
            $group.attr('aria-labelledby', legendId);
            $legend.attr('tabindex', '-1');
        }
        $inputs.attr({
            tabindex: '-1',
            'aria-hidden': 'true'
        });
        let totalEnabled = $inputs.filter(':not(:disabled)').length;
        $labels.each(function (index) {
            let $label = $(this);
            let inputId = $label.attr('for');
            let $input = $group.find(
                '> .variant-input > input[type="radio"]#' +
                CSS.escape(inputId)
            );
            let disabled = !$input.length || $input.prop('disabled');
            $label.attr({
                role: 'radio',
                'aria-checked': 'false',
                tabindex: '-1',
                'aria-setsize': totalEnabled
            });
            if (disabled) {
                $label.attr({
                    'aria-disabled': 'true'
                });
            } else {
                $label.removeAttr('aria-disabled');
            }
        });
        let position = 0;
        $labels.each(function () {
            let $label = $(this);
            let inputId = $label.attr('for');
            let $input = $group.find(
                '> .variant-input > input[type="radio"]#' +
                CSS.escape(inputId)
            );
            if (!$input.length || $input.prop('disabled')) {
                return;
            }
            position++;
            $label.attr({
                'aria-posinset': position
            });
            if ($input.prop('checked')) {
                $label.attr({
                    tabindex: '0',
                    'aria-checked': 'true'
                });
            }
        });
        if (!$labels.filter('[tabindex="0"]').length) {
            let $firstEnabled = $labels.filter(function () {
                let inputId = $(this).attr('for');
                return $group.find(
                    '> .variant-input > input[type="radio"]#' +
                    CSS.escape(inputId) +
                    ':not(:disabled)'
                ).length;
            }).first();
            if ($firstEnabled.length) {
                $firstEnabled.attr('tabindex', '0');
            }
        }
        let selectVariantRadio = function ($label, shouldFocus) {
            let inputId = $label.attr('for');
            let $input = $group.find(
                '> .variant-input > input[type="radio"]#' +
                CSS.escape(inputId)
            );
            if (!$input.length || $input.prop('disabled')) {
                return;
            }
            $labels.attr({
                tabindex: '-1',
                'aria-checked': 'false'
            });
            $label.attr({
                tabindex: '0',
                'aria-checked': 'true'
            });
            $input
                .prop('checked', true)
                .trigger('change');
            if (shouldFocus && $label[0]) {
                $label[0].focus();
            }
        };
        $labels
            .off('click.productVariantRadioAccessibility')
            .on(
                'click.productVariantRadioAccessibility',
                function () {
                    selectVariantRadio($(this), false);
                }
            );
        $labels
            .off('keydown.productVariantRadioAccessibility')
            .on(
                'keydown.productVariantRadioAccessibility',
                function (e) {
                    let $currentLabel = $(this);
                    if (e.key === ' ' || e.key === 'Enter') {
                        e.preventDefault();
                        selectVariantRadio(
                            $currentLabel,
                            false
                        );
                        return;
                    }
                    if (
                        e.key !== 'ArrowRight' &&
                        e.key !== 'ArrowLeft' &&
                        e.key !== 'ArrowDown' &&
                        e.key !== 'ArrowUp'
                    ) {
                        return;
                    }
                    e.preventDefault();
                    let $enabledLabels = $labels.filter(function () {
                        let inputId = $(this).attr('for');
                        return $group.find(
                            '> .variant-input > input[type="radio"]#' +
                            CSS.escape(inputId) +
                            ':not(:disabled)'
                        ).length;
                    });
                    if (!$enabledLabels.length) return;
                    let currentIndex =
                        $enabledLabels.index(this);
                    if (currentIndex === -1) {
                        currentIndex = 0;
                    }
                    let newIndex;
                    if (
                        e.key === 'ArrowRight' ||
                        e.key === 'ArrowDown'
                    ) {
                        newIndex =
                            (currentIndex + 1) %
                            $enabledLabels.length;

                    } else {
                        newIndex =
                            (
                                currentIndex -
                                1 +
                                $enabledLabels.length
                            ) %
                            $enabledLabels.length;
                    }
                    let $newLabel =
                        $enabledLabels.eq(newIndex);
                    selectVariantRadio(
                        $newLabel,
                        true
                    );
                }
            );
        $legend
            .off('focus.productVariantRadioAccessibility')
            .on(
                'focus.productVariantRadioAccessibility',
                function () {
                    let $selectedLabel =
                        $labels.filter(
                            '[aria-checked="true"]'
                        ).first();
                    if (!$selectedLabel.length) {
                        $selectedLabel =
                            $labels.filter(
                                '[tabindex="0"]'
                            ).first();
                    }
                    if ($selectedLabel.length) {
                        setTimeout(function () {
                            $selectedLabel[0].focus();
                        }, 0);
                    }
                }
            );
    });
};
applyProductVariantRadioAccessibility();
a11yObserve(applyProductVariantRadioAccessibility);
// 
$("br").attr("aria-hidden", "true");
$(".jdgm-form .jdgm-form__title").attr({"role":"heading", "aria-level":"2"});
$('#CartDrawer').on('keydown', function (e) {
    if (e.key === 'Tab' && e.shiftKey) {
        const $items = $(this).find(
            'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
        ).filter(':visible:not(:disabled)');

        if (document.activeElement === $items[0]) {
            e.preventDefault();
            $items.last().focus();
        }
    }
});
(function () {
    const jdgmCarouselA11yObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            const jdgmCarouselItem = entry.target;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                jdgmCarouselItem.removeAttribute('inert');
                jdgmCarouselItem.removeAttribute('aria-hidden');
            } else {
                jdgmCarouselItem.setAttribute('inert', '');
                jdgmCarouselItem.setAttribute('aria-hidden', 'true');
            }
        });
    }, {
        root: document.querySelector('.jdgm-carousel__item-container'),
        threshold: [0, 0.5, 1]
    });

    function initJdgmCarouselA11y() {
        $('.jdgm-carousel').each(function () {
            const jdgmCarousel = this;
            const jdgmCarouselContainer = jdgmCarousel.querySelector(
                '.jdgm-carousel__item-container'
            );

            if (!jdgmCarouselContainer) {
                return;
            }

            jdgmCarouselContainer
                .querySelectorAll('.jdgm-carousel-item')
                .forEach(function (jdgmCarouselItem) {
                    jdgmCarouselA11yObserver.observe(jdgmCarouselItem);
                });
        });
    }

    initJdgmCarouselA11y();

    const jdgmCarouselMutationObserver = new MutationObserver(function () {
        initJdgmCarouselA11y();
    });

    document.querySelectorAll('.jdgm-carousel').forEach(function (jdgmCarousel) {
        jdgmCarouselMutationObserver.observe(jdgmCarousel, {
            childList: true,
            subtree: true
        });
    });
})();
// slide buttons for products
function addCollectionSliderButtons() {
        $('.grid-overflow-wrapper').each(function () {
            const wrapper = $(this);
            if (wrapper.find('.custom-collection-prev').length) {return;}
            const grid = wrapper.find('.grid--uniform').first();
            if (!grid.length) {return;}
            const items = grid.children('.grid__item');
            if (items.length < 2) {return;}
            wrapper.prepend(`
                <button type="button" class="custom-collection-prev" aria-label="Previous products">
                    <svg aria-hidden="true" viewBox="0 0 24 24">
                        <path d="M15 18L9 12L15 6"></path>
                    </svg></button>`);
            wrapper.append(`
                <button type="button" class="custom-collection-next" aria-label="Next products">
                    <svg aria-hidden="true" viewBox="0 0 24 24">
                        <path d="M9 18L15 12L9 6"></path>
                    </svg></button>`);
            updateCollectionSliderButtons(wrapper);
        });}
    function updateCollectionSliderButtons(wrapper) {
        const grid = wrapper.find('.grid--uniform').first();
        if (!grid.length) {return;}
        const maxScroll =grid[0].scrollWidth - grid[0].clientWidth;
        const currentScroll = grid[0].scrollLeft;
        wrapper.find('.custom-collection-prev').prop('disabled', currentScroll <= 1).attr('aria-disabled',currentScroll <= 1 ? 'true' : 'false');
        wrapper.find('.custom-collection-next').prop('disabled', currentScroll >= maxScroll - 1).attr('aria-disabled',currentScroll >= maxScroll - 1 ? 'true' : 'false');
    }
    $(document).on('click','.custom-collection-prev, .custom-collection-next',
        function (e) {
            e.preventDefault();
            e.stopPropagation();
            const button = $(this);
            const wrapper = button.closest('.grid-overflow-wrapper');
            const grid = wrapper.find('.grid--uniform').first();
            if (!grid.length) {return;}
            const firstItem = grid.children('.grid__item').first();
            if (!firstItem.length) {return;}
            const scrollAmount = firstItem.outerWidth(true);
            grid[0].scrollBy({left: button.hasClass('custom-collection-next') ? scrollAmount : -scrollAmount, behavior: 'smooth'});
            setTimeout(function () {updateCollectionSliderButtons(wrapper);}, 400);}
    );
    $('.grid-overflow-wrapper .grid--uniform').on('scroll',
        function () {
            updateCollectionSliderButtons($(this).closest('.grid-overflow-wrapper'));}
    );
    a11yObserve(addCollectionSliderButtons);
    addCollectionSliderButtons();
// 
// Move focus into the Judge.me review form when "Write a review" is activated.
document.addEventListener("click", function (e) {
    if (!e.target.closest("#judgeme_product_reviews .jdgm-write-rev-link")) return;
    setTimeout(function () {
        document.querySelector(
            "#judgeme_product_reviews form.jdgm-form .jdgm-form__rating .jdgm-star"
        )?.focus();
    }, 100);
});
if ($('.recipient-form .recipient-fields__field textarea[name="properties[Message]"]').length) {
    let $textarea = $('.recipient-form .recipient-fields__field textarea[name="properties[Message]"]');
    let $counter = $('.recipient-form #recipient_message_textarea');
    $counter.attr('aria-hidden', 'true');
    let counterId = 'message-character-count-' + $textarea.attr('id');
    let $srText = $('.recipient-form #' + counterId);
    if (!$srText.length) {
        $srText = $('<span></span>')
            .attr('id', counterId)
            .insertAfter($counter);
    }
    $textarea.attr('aria-describedby', counterId);
    let updateCounter = function () {
        let remaining = 200 - $textarea.val().length;
        $srText.text(
            remaining + ' characters remaining. Maximum 200 characters.'
        );
    };
    updateCounter();
    $textarea.on('input', updateCounter);
}
$(document)
    .off('click.cartCheckoutA11y', 'form#CartPageForm .cart__checkout-wrapper button.cart__checkout')
    .on('click.cartCheckoutA11y', 'form#CartPageForm .cart__checkout-wrapper button.cart__checkout', function () {
        $('#cart-checkout-status').text('');
        setTimeout(function () {
            $('#cart-checkout-status').text('Loading, please wait.');
        }, 50);
    });
$(document)
    .off('keydown.cartCheckoutA11y', 'form#CartPageForm .cart__checkout-wrapper button.cart__checkout')
    .on('keydown.cartCheckoutA11y', 'form#CartPageForm .cart__checkout-wrapper button.cart__checkout', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            $('#cart-checkout-status').text('');
            setTimeout(function () {
                $('#cart-checkout-status').text('Loading, please wait.');
            }, 50);
        }
    });

// 
if (window.matchMedia('(max-width: 767px)').matches) {
    $(document).on('click', '.quick-product__btn', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $btn = $(this);
        var match = $btn.attr('class').match(/js-modal-open-quick-modal-(\d+)/);
        if (!match) return;
        var productId = match[1];
        var $modal = $('#QuickShopModal-' + productId);
        var $holder = $modal.find('[id^="QuickShopHolder-"]');
        if (!$modal.length || !$holder.length) return;
        var handle = $holder.attr('id').replace('QuickShopHolder-', '');
        if (typeof theme.preloadProductModal === 'function') {
            theme.preloadProductModal(
                handle,
                productId,
                $btn[0]
            );
        }
        var checkContent = setInterval(function () {
            if ($modal.find('[data-blocks-holder].product-form-holder--loaded').length) {
                clearInterval(checkContent);
                $modal
                    .addClass('modal--is-active')
                    .show();
                $modal.attr('aria-hidden', 'false');
                focusQuickShop();
            }
        }, 100);
        setTimeout(function () {
            clearInterval(checkContent);
            $modal
                .addClass('modal--is-active')
                .show();
        }, 5000);
    });
}
// //
$(document).on("change", "#FilterDrawer input.tag__input[type='checkbox']", function () {
    let filterCount = $("#FilterDrawer input.tag__input[type='checkbox']:checked").length;
    if (!$("#filter-announcement").length) {
        $("<div>", {
            id: "filter-announcement",
            "aria-live": "polite",
            "aria-atomic": "true"
        }).css({
            position: "absolute",
            width: "1px",
            height: "1px",
            padding: "0",
            margin: "-1px",
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            border: "0"
        }).appendTo("body");
    }
    setTimeout(function () {
        $("#filter-announcement").text(
            filterCount === 0
                ? "No filters applied."
                : filterCount === 1
                    ? "1 filter applied."
                    : filterCount + " filters applied."
        );
    }, 100);
});
// Run every registered fix once now, so they apply even if the page never changes.
runA11yFixes();
});